import {
    Center,
    Container,
    Stack,
    Text,
    Title
} from "@mantine/core";
import {useEffect} from "react";
import {
    ApplicationProduct,
    Product
} from "../types.ts";
import {useApplicationProducts} from "../../application-products";
import {ApplicationProductsComponent} from "../components/ApplicationProductsComponent.tsx";
import {moduleConfig} from "../config";


export const PricingPage = () => {

    const {
        items: applicationProducts,
        handleFetchRecords
    } = useApplicationProducts();

    useEffect(() => {
        handleFetchRecords()
    }, []);


    let products: Product[] = [];
    if (applicationProducts) {
        products = applicationProducts?.map((applicationProduct: ApplicationProduct) => applicationProduct.product);
    }


    return (
        <Stack align={'center'}>

            <Center>
                <Title>
                    <Text style={{
                        marginTop: 'var(--mantine-spacing-xl)',
                        color: 'var(--mantine-color-dark-3)'
                    }}>
                        {moduleConfig.pricingPageTitle}
                    </Text>
                </Title>
            </Center>

            <Container>
                <ApplicationProductsComponent products={products}/>
            </Container>

            <Container>
                <Text style={{
                    fontSize: 'small',
                    fontWeight: '800',
                    textAlign: 'center',
                }}>
                    {moduleConfig.pricingPageSmallScript}
                </Text>
            </Container>


        </Stack>
    )

};
